import { MARQUEE_ITEMS } from "@/data/content";

export default function Marquee() {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div data-testid="editorial-marquee" className="overflow-hidden border-y border-amber-500/30 bg-navy py-4">
      <div className="marquee-track">
        {items.map((item, i) => (
          <span key={i} className="flex items-center whitespace-nowrap">
            <span className="px-8 font-display text-sm font-bold uppercase tracking-[0.2em] text-slate-300">
              {item}
            </span>
            <span className="h-1.5 w-1.5 rounded-full bg-amber-500" />
          </span>
        ))}
      </div>
    </div>
  );
}
